import { Box, Chip, Grid, Skeleton, Typography } from "@mui/material";
import DescripCategoryCard from "../../components/DescripCategoryCard";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  homepageActions,
  selectGenres,
  selectGenresLoading,
  selectLoading,
} from "../../saga/homepageSlice";
import { useEffect } from "react";
import { searchStoreActions } from "features/searchStore/saga/searchStoreSlice";
import { useNavigate } from "react-router-dom";

export function SearchByGenre() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const genreList = useAppSelector(selectGenres);
  const isLoading = useAppSelector(selectGenresLoading);

  const topGenre = genreList.slice(0, 8);
  const subGenre = genreList.slice(8);

  const handleClick = (e: any) => {
    dispatch(searchStoreActions.setSingleGenre(e));
    navigate("/stores");
  };

  useEffect(() => {
    dispatch(homepageActions.getFoodGenres(8));
  }, [dispatch]);

  if (!genreList || genreList === undefined || genreList.length === 0) {
    return (
      <Box my={10}>
        <Typography variant="h5" fontWeight="bold">
          料理ジャンルから探す
        </Typography>
        <Grid container rowGap={2} spacing={2} sx={{ my: 0 }}>
          {isLoading ? (
            <>
              <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
                <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
              </Grid>
              <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
                <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
              </Grid>
              <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
                <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
              </Grid>
              <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
                <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
              </Grid>
            </>
          ) : (
            <Typography variant="h5">料理ジャンルリストは空です</Typography>
          )}
        </Grid>
      </Box>
    );
  }

  return (
    <Box my={10}>
      <Typography variant="h5" fontWeight="bold">
        料理ジャンルから探す
      </Typography>

      <Grid container rowGap={2} spacing={2} sx={{ my: 0 }}>
        {isLoading ? (
          <>
            <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
              <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
            </Grid>
            <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
              <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
            </Grid>
            <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
              <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
            </Grid>
            <Grid item xl={3} lg={4} md={4} sm={4} xs={12}>
              <Skeleton width="100%" height="300px" sx={{ mx: 2 }} />
            </Grid>
          </>
        ) : (
          topGenre.map((e) => (
            <Grid
              key={e.Id}
              item
              xl={3}
              lg={4}
              md={4}
              sm={4}
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <DescripCategoryCard
                id={e.Id}
                bgImg={e.Images}
                title={e.Name}
                storeNum={e.StoreCount}
                description={e.Description}
                handleClick={handleClick}
              />
            </Grid>
          ))
        )}
      </Grid>

      <Box display="flex" flexWrap="wrap" my={3}>
        {subGenre.map((e) => (
          // <Box
          //   key={e.Id}
          //   border={1}
          //   borderRadius={1}
          //   borderColor="divider"
          //   sx={{
          //     padding: 1,
          //     marginRight: 2,
          //     my: 2,
          //     "&:hover": {
          //       cursor: "pointer",
          //       color: "primary.main",
          //       borderColor: "primary.main",
          //     },
          //   }}
          //   onClick={() => handleClick(e.Id)}
          // >
          //   <Typography variant="subtitle2">{e.Name}</Typography>
          // </Box>
          <Chip
            label={e.Name}
            sx={{
              p: 1,
              marginRight: 2,
              mt: 1,
              cursor: "pointer",
              "&:hover": {
                opacity: 0.6,
              },
              "& .MuiChip-label": {
                fontSize: "13px",
                lineHeight: "13px",
              },
            }}
            onClick={() => handleClick(e.Id)}
          />
        ))}
      </Box>

      {/* <Box display="flex" justifyContent="end">
        <Button variant="text" startIcon={<ArrowRight />}>
          Go to list
        </Button>
      </Box> */}
    </Box>
  );
}
